import { render, staticRenderFns } from "./square_list.vue?vue&type=template&id=0a2c7a64&scoped=true"
import script from "./square_list.vue?vue&type=script&lang=js"
export * from "./square_list.vue?vue&type=script&lang=js"
import style0 from "./square_list.vue?vue&type=style&index=0&id=0a2c7a64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c7a64",
  null
  
)

export default component.exports